function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 1024 1024",
    style: {
      display: "inline-block",
      verticalAlign: "middle"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M884.364 93.091l-65.164 74.473-474.764 484.073-204.8-204.8-139.636 139.636 65.164 65.164 214.109 204.8 74.473 74.473 65.164-74.473 539.927-558.545 65.164-74.473-139.636-130.327z",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.385fdb08c8974cc587f5b8102ea42b07.svg";
export { ForwardRef as ReactComponent };